<mat-stepper linear #stepper [selectedIndex]="wizardStep">
  <mat-step [stepControl]="unuKeysFormGroup" [editable]="true">
    <h3>{{"kf-reporting.wizard.groups.unu-keys.header" | translate}}</h3>
    <form [formGroup]="unuKeysFormGroup" (ngSubmit)="submitUNUKeysForm()">
      <ng-template matStepLabel>UNU-Keys</ng-template>
      <label>{{"kf-reporting.wizard.groups.unu-keys.label" | translate}}</label>
      <mat-radio-group formControlName="unuKeyOption" [value]="unuKeySelectedOption" (change)="onUNUKeyOptionChange($event)" color="primary">
        <mat-radio-button [value]="1">
          create a new set from the current list of active UNU-Keys
        </mat-radio-button>
        <mat-radio-button [value]="2">
          reuse a set from a previous Report Cycle
        </mat-radio-button>
        <mat-radio-button [value]="3">
          update the current list of active UNU-Keys first. I will return here when I am done
        </mat-radio-button>
      </mat-radio-group>

      <div class="set-name" *ngIf="unuKeySelectedOption === 1">
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label>Provide a name for the set</mat-label>
          <input matInput formControlName="setName">
          <mat-error>Please fill in a name</mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="unuKeySelectedOption === 2">
        <p>To reuse a set of UNU-Keys from a previous Report Cycle, select the set below</p>
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label> UNU-Keys sets</mat-label>
          <mat-select formControlName="previousSet" [compareWith]="compareMasters" (selectionChange)="onUnuKeySetChange($event)">
            <mat-option [value]="item" *ngFor="let item of previousUnuKeySets">{{item.value}}</mat-option>
          </mat-select>
          <mat-error>Please select a set</mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="UNUKeys?.content">
        <h3 class="table-title">List of selected UNU-Keys</h3>
        <app-kf-next-report-master-table
          [page]="UNUKeys.number"
          [pageSize]="UNUKeys.size"
          [totalElements]="UNUKeys.totalElements"
          [list]="UNUKeys.content"
          (loadItems)="loadUNUKeys($event)">
        </app-kf-next-report-master-table>
      </div>
      <div class="wizard-buttons-container align-right">
        <button mat-raised-button (click)="goBack()">
          <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
          <span>Back</span>
        </button>
        <button mat-raised-button (click)="nextStep()" color="primary" [disabled]="unuKeysFormGroup?.invalid">
          <span>Save & Next</span>
          <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
        </button>
<!--        <span>{{'errors ' + (unuKeysFormGroup.errors | json) }}</span>-->
<!--        <span>{{'unuKeyOption ' + (unuKeysFormGroup.controls.unuKeyOption.errors | json) }}</span>-->
<!--        <span>{{'setName ' + (unuKeysFormGroup.controls.setName.errors | json) }}</span>-->
<!--        <span>{{'previousUNUKeySet ' + (unuKeysFormGroup.controls.previousSet.errors | json) }}</span>-->
<!--        <span>{{unuKeysFormGroup.invalid}}</span>-->
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="categoriesForm" [editable]="true">
    <form [formGroup]="categoriesForm" (ngSubmit)="submitCategoriesForm()">
      <ng-template matStepLabel>Put On Market Categories</ng-template>
      <label>{{"kf-reporting.wizard.groups.unu-keys.label" | translate}}</label>
      <mat-radio-group formControlName="categoriesOption" [value]="categoriesSelectedOption" (change)="onCategoriesOptionChange($event)" color="primary">
        <mat-radio-button [value]="1">
          create a new set from the current list of active Put On Market Categories
        </mat-radio-button>
        <mat-radio-button [value]="2">
          reuse a set from a previous Report Cycle
        </mat-radio-button>
        <mat-radio-button [value]="3">
          update the current list of active Put On Market Categories first
        </mat-radio-button>
      </mat-radio-group>

      <div class="set-name" *ngIf="categoriesSelectedOption === 1">
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label>Provide a name for the set</mat-label>
          <input matInput formControlName="setName">
        </mat-form-field>
      </div>

      <div *ngIf="categoriesSelectedOption === 2">
        <p>To reuse a set of Put On Market Categories from a previous Report Cycle, select the set below</p>
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label> Categories sets</mat-label>
          <mat-select formControlName="previousSet" [compareWith]="compareMasters" (selectionChange)="onCategorySetChange($event)">
            <mat-option [value]="item" *ngFor="let item of previousCategoriesSets">{{item.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="categories?.content">
        <h3 class="table-title">List of selected Put On Market Categories</h3>
        <app-kf-next-report-master-table
          [page]="categories.number"
          [pageSize]="categories.size"
          [totalElements]="categories.totalElements"
          [list]="categories.content"
          (loadItems)="loadCategories($event)">
        </app-kf-next-report-master-table>
      </div>
      <div class="wizard-buttons-container align-right">
        <button mat-raised-button (click)="previousStep()">
          <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
          <span>Back</span>
        </button>
        <button mat-raised-button (click)="nextStep()" color="primary" [disabled]="categoriesForm?.invalid">
          <span>Save & Next</span>
          <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="collectionStreamsForm" [editable]="true">
    <form [formGroup]="collectionStreamsForm" (ngSubmit)="submitCollectionStreamsForm()">
      <ng-template matStepLabel>Collection Streams</ng-template>
      <label>{{"kf-reporting.wizard.groups.unu-keys.label" | translate}}</label>
      <mat-radio-group formControlName="collectionStreamsOption" [value]="collectionStreamsSelectedOption" (change)="onCollectionStreamsOptionChange($event)" color="primary">
        <mat-radio-button [value]="1">
          create a new set from the current list of active Collection Streams
        </mat-radio-button>
        <mat-radio-button [value]="2">
          reuse a set from a previous Report Cycle
        </mat-radio-button>
        <mat-radio-button [value]="3">
          update the current list of active Collection Streams first
        </mat-radio-button>
      </mat-radio-group>

      <div class="set-name" *ngIf="collectionStreamsSelectedOption === 1">
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label>Provide a name for the set</mat-label>
          <input matInput formControlName="setName">
        </mat-form-field>
      </div>

      <div *ngIf="collectionStreamsSelectedOption === 2">
        <p>To reuse a set of Put On Market Categories from a previous Report Cycle, select the set below</p>
        <mat-form-field appearance="outline" color="primary" class="full-width-input">
          <mat-label> Categories sets</mat-label>
          <mat-select formControlName="previousSet" [compareWith]="compareMasters" (selectionChange)="onCollectionStreamSetChange($event)">
            <mat-option [value]="item" *ngFor="let item of previousCollectionStreamsSets">{{item.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="collectionStreams?.content">
        <h3 class="table-title">List of selected Collection Streams (POM)</h3>
        <app-kf-next-report-master-table
          [page]="collectionStreams.number"
          [pageSize]="collectionStreams.size"
          [totalElements]="collectionStreams.totalElements"
          [list]="collectionStreams.content"
          (loadItems)="loadCollectionStreams($event)">
        </app-kf-next-report-master-table>
      </div>
      <div class="wizard-buttons-container align-right">
        <button mat-raised-button (click)="previousStep()">
          <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
          <span>Back</span>
        </button>
        <button mat-raised-button (click)="nextStep()" color="primary" [disabled]="collectionStreamsForm?.invalid">
          <span>Save & Next</span>
          <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [editable]="true">
    <ng-template matStepLabel>Reporting Groups</ng-template>
    <div>
      <div class="summary-container">
        <div class="summary-button-container">
          <button mat-mini-fab color="primary" (click)="goToStep(0)"> 1</button>
        </div>
       <div class="summary-text-container">
         <span>{{reportCycle.unuKeySetName || 'Undefined'}}</span>
       </div>
      </div>
      <div class="summary-container">
        <div class="summary-button-container">
          <button mat-mini-fab color="primary" (click)="goToStep(1)">2</button>
        </div>
        <div class="summary-text-container">
          <span>{{reportCycle.kfCategorySetName || 'Undefined'}}</span>
        </div>
      </div>
      <div class="summary-container">
        <div class="summary-button-container">
          <button mat-mini-fab color="primary" (click)="goToStep(2)">3</button>
        </div>
        <div class="summary-text-container">
          <span>{{reportCycle.collectionStreamName || 'Undefined'}}</span>
        </div>
      </div>
    </div>
    <div class="wizard-buttons-container align-right">
      <button mat-raised-button (click)="previousStep()">
        <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
        <span>Back</span>
      </button>
      <button mat-raised-button color="primary" [disabled]="unuKeysFormGroup?.invalid || categoriesForm?.invalid || collectionStreamsForm?.invalid" (click)="continue()">
        <span>Save & Next</span>
        <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
      </button>
    </div>
  </mat-step>

</mat-stepper>
